/**
 * useIsOrgAdmin (SYN-1938) — org-admin predicate hook.
 *
 * True when the current org membership is "admin" or "owner".
 * False for member, viewer, or no current org.
 *
 * This hook is ONLY the org-admin predicate. It does NOT absorb
 * isPlatformAdmin / super-admin checks. Callers that need combined
 * access (isPlatformAdmin || isOrgAdmin) must OR both operands explicitly.
 */

import { useOrgContext } from "../providers/OrgProvider";

export function useIsOrgAdmin(): boolean {
  const { currentOrg } = useOrgContext();
  return currentOrg?.role === "admin" || currentOrg?.role === "owner";
}
